import { render, staticRenderFns } from "./TypeCertificateCard.vue?vue&type=template&id=ec489c14&scoped=true&"
import script from "./TypeCertificateCard.vue?vue&type=script&lang=js&"
export * from "./TypeCertificateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec489c14",
  null
  
)

export default component.exports